<script>
	import { panelController } from './../../../../stores/service.js';
    import { editPreguntas } from "../../../../Controller/analytics/editPreguntas";

    import { navigate } from "svelte-routing";

    document.title = "Ratingg | Lista de ratinggs";

    let dataview = {
        date: "",
        name: "",
        edit: true,
        inputs: {
            name: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            modo: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            autenticacion: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            opcpin: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
            pin: {
                value: "",
                status: false,
                valid: {
                    text: "",
                    style: "",
                },
            },
        },
    };

    export let data = { service: {}, index: 0 };

    let panelcofig;

    let preguntas = [];

    function main() {
        panelcofig = new editPreguntas(data.service, data.index);
        reset();
    }

    function reset() {
        console.log(panelcofig.preguntas, !panelcofig.preguntas.length == 0);
        if (panelcofig.preguntas.length == 0) {
            return;
        }
        preguntas = panelcofig.reset();
    }

    function mainedit(){
        $panelController.viewPanel.status = true;
          $panelController.viewPanel.nav = true;
          $panelController.viewPanel.name = $panelController.service.listRatinggs[data.index].config.name;
          $panelController.viewPanel.index=[data.index,0];
          navigate("/panel", { replace: true });
    }

    main();

    function save() {
        if (!data.inputs.modo.valid.valid || !data.inputs.name.valid.valid) {
            return;
        }

        if (data.inputs.opcpin.value) {
            if (!data.inputs.pin.valid.valid) {
                return;
            }
        }

        console.log("guardar", data);
    }

    function btn_cancelar() {
        reset();
    }

    function validMode() {
        /* console.log(this.dataView.inputs.modo.value,this.dataView,value); */

        if (data.inputs.modo.value == 0) {
            data.inputs.modo.valid.text = "No valido";
            data.inputs.modo.valid.style = "valid-i";
            data.inputs.modo.valid.valid = false;
        } else {
            data.inputs.modo.valid.text = "Selecionado";
            data.inputs.modo.valid.style = "valid-c";
            data.inputs.modo.valid.valid = true;
        }
    }

    function btn_editar() {
        data.edit = false;
        panelcofig.dataView = data;
    }

    function validLogin() {
        console.log(data.inputs.autenticacion);
        if (data.inputs.autenticacion.value) {
            data.inputs.autenticacion.valid.text = "Activado";
            data.inputs.autenticacion.valid.style = "valid-c";
            data.inputs.autenticacion.valid.valid = true;
        } else {
            data.inputs.autenticacion.valid.text = "Desactivado";
            data.inputs.autenticacion.valid.style = "valid-i";
            data.inputs.autenticacion.valid.valid = false;
        }
    }

    function validName() {
        const ep = /^[0-9\w'\-,.][^_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,30}$/;

        if (ep.test(data.inputs.name.value)) {
            data.inputs.name.valid.text = "Nombre valido";
            data.inputs.name.valid.style = "valid-c";
            data.inputs.name.valid.valid = true;
        } else {
            data.inputs.name.valid.text =
                "El nombre contiene un carácter no valido o es corto";
            data.inputs.name.valid.style = "valid-i";
            data.inputs.name.valid.valid = false;
        }
    }

    function validPINCheck() {
        if (data.inputs.opcpin.value) {
            data.inputs.opcpin.valid.text = "Activado";
            data.inputs.opcpin.valid.style = "valid-c";
            data.inputs.opcpin.valid.valid = true;
            data.inputs.pin.valid.valid = false;
            data.inputs.opcpin.valid.valid = false;
            data.inputs.pin.valid.text = "El PIN debe contener 4 dígitos";
        } else {
            data.inputs.opcpin.valid.text = "Desactivado";
            data.inputs.opcpin.valid.style = "valid-i";
        }
    }

    function validPN() {
        const ep = /^\d{4}$/;
        if (ep.test(data.inputs.pin.value)) {
            data.inputs.pin.valid.text = "PIN valido";
            data.inputs.pin.valid.style = "valid-c";
            data.inputs.pin.valid.valid = true;
        } else {
            data.inputs.pin.valid.text = "El PIN debe contener 4 dígitos";
            data.inputs.pin.valid.style = "valid-i";
            data.inputs.pin.valid.valid = false;
        }
    }
</script>

<div class="col-md-12">
    <!-- AREA CHART -->
    <div class="card card-info">
        <div class="card-header">
            <h3 class="card-title">Listado de preguntas</h3>

            <div class="card-tools">
                <button type="button" class="btn btn-tool" on:click={() => {mainedit()}}>
                    <i class="ion ion-edit" />
                </button>
            </div>
        </div>

        <div class="card-body">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Pregunta</th>
                        <th scope="col">Tipo</th>
                       <!--  <th scope="col">Ordenar</th>
                        <th scope="col">Opciones</th> -->
                    </tr>
                </thead>
                <tbody>
                    {#each preguntas as item, index}
                        <tr>
                            <th scope="row"> {index + 1} </th>
                            <td>
                                {item.pregunta}
                            </td>
                            <td>
                                {#if item.tipo == 1}
                                    Multiple
                                {/if}
                                {#if item.tipo == 2}
                                    3 opciones
                                {/if}
                                {#if item.tipo == 3}
                                    Rango
                                {/if}
                                {#if item.tipo == 4}
                                    Normal
                                {/if}
                            </td>

                            <!-- <td>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    on:click={() => {}}
                                >
                                    Subir
                                    <i class="bi bi-sort-up"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    on:click={() => {}}
                                >
                                    Bsjar
                                    <i class="bi bi-sort-down"></i>
                                </button>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    class="btn btn-outline-danger"
                                    on:click={() => {}}
                                >
                                    Eliminar
                                    <i class="bi bi-trash"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-outline-primary"
                                    on:click={() => {}}
                                >
                                    Editar
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                            </td>
                            {#if dataView.eye[index]}
                                <td colspan="6">
                                    
                                    
                                </td>
                            {/if} -->
                        </tr>
                    {/each}
                </tbody>
            </table>
        </div>

        <!-- /.card-body -->
    </div>
    <!-- /.card -->
</div>

<style>
    .form-control {
        text-align: center;
    }
    .valid-c {
        color: green;
    }
    .valid-i {
        color: red;
    }
</style>
